import { tourContent } from './tourContent';

// Tour steps configuration for different pages
export const tourSteps = {
  codeEditor: [
    {
      target: '[data-tour="file-explorer"]',
      ...tourContent.codeEditor.fileExplorer
    },
    {
      target: '[data-tour="download-repository"]',
      ...tourContent.codeEditor.downloadRepository
    },
    {
      target: '[data-tour="expand-commit"]',
      ...tourContent.codeEditor.expandCommit
    },
    {
      target: '[data-tour="reset-to-commit"]',
      ...tourContent.codeEditor.resetToCommit
    }
  ],

  header: [
    // Main Navigation Buttons
    {
      target: '[data-tour="chat-nav-button"]',
      ...tourContent.header.chatNavButton
    },
    {
      target: '[data-tour="code-nav-button"]',
      ...tourContent.header.codeNavButton
    },
    {
      target: '[data-tour="security-nav-button"]',
      ...tourContent.header.securityNavButton
    },
    // Thread Navigation
    {
      target: '[data-tour="project-to-thread-button"]',
      ...tourContent.header.projectToThreadButton
    },
    {
      target: '[data-tour="back-to-project-button"]',
      ...tourContent.header.backToProjectButton
    },
    {
      target: '[data-tour="thread-chat-tab"]',
      ...tourContent.header.threadChatTab
    },
    {
      target: '[data-tour="thread-tasks-tab"]',
      ...tourContent.header.threadTasksTab
    },
    {
      target: '[data-tour="thread-code-tab"]',
      ...tourContent.header.threadCodeTab
    },
    // User Interface Controls
    {
      target: '[data-tour="sandbox-status"]',
      ...tourContent.header.sandboxStatus
    },
    {
      target: '[data-tour="user-menu-button"]',
      ...tourContent.header.userMenuButton
    },
    {
      target: '[data-tour="dark-mode-toggle"]',
      ...tourContent.header.darkModeToggle
    },
    {
      target: '[data-tour="help-button"]',
      ...tourContent.header.helpButton
    },
    // Bug Report System
    {
      target: '[data-tour="bug-report-button"]',
      ...tourContent.header.bugReportButton
    },
    {
      target: '[data-tour="bug-report-issue-type"]',
      ...tourContent.header.bugReportIssueType
    },
    {
      target: '[data-tour="bug-report-description"]',
      ...tourContent.header.bugReportDescription
    },
    {
      target: '[data-tour="bug-report-screenshot"]',
      ...tourContent.header.bugReportScreenshot
    },
    {
      target: '[data-tour="bug-report-submit"]',
      ...tourContent.header.bugReportSubmit
    }
  ],

  // Project Settings Page
  projectSettings: [
    {
      target: '[data-tour="back-to-project"]',
      ...tourContent.projectSettings.backToProject
    },
    {
      target: '[data-tour="settings-general"]',
      ...tourContent.projectSettings.settingsGeneral
    },
    {
      target: '[data-tour="settings-delete"]',
      ...tourContent.projectSettings.settingsDelete
    },
    {
      target: '[data-tour="delete-project-button"]',
      ...tourContent.projectSettings.deleteProjectButton
    }
  ],

  // Account Settings
  account: [
    // Navigation sections
    {
      target: '[data-tour="account-profile"]',
      ...tourContent.account.accountProfile
    },
    {
      target: '[data-tour="account-password"]',
      ...tourContent.account.accountPassword
    },
    {
      target: '[data-tour="account-plan"]',
      ...tourContent.account.accountPlan
    },
    {
      target: '[data-tour="account-credits"]',
      ...tourContent.account.accountCredits
    },
    {
      target: '[data-tour="account-billing"]',
      ...tourContent.account.accountBilling
    },
    {
      target: '[data-tour="account-notifications"]',
      ...tourContent.account.accountNotifications
    },
    {
      target: '[data-tour="account-security"]',
      ...tourContent.account.accountSecurity
    },
    
    // Action buttons
    {
      target: '[data-tour="edit-profile-button"]',
      ...tourContent.account.editProfileButton
    },
    {
      target: '[data-tour="save-profile-button"]',
      ...tourContent.account.saveProfileButton
    },
    {
      target: '[data-tour="verify-email-button"]',
      ...tourContent.account.verifyEmailButton
    },
    {
      target: '[data-tour="change-password-button"]',
      ...tourContent.account.changePasswordButton
    },
    {
      target: '[data-tour="save-notifications-button"]',
      ...tourContent.account.saveNotificationsButton
    },
    {
      target: '[data-tour="toggle-mfa-button"]',
      ...tourContent.account.toggleMfaButton
    },
    {
      target: '[data-tour="cancel-mfa-setup"]',
      ...tourContent.account.cancelMfaSetup
    },
    {
      target: '[data-tour="verify-mfa-code"]',
      ...tourContent.account.verifyMfaCode
    },
    {
      target: '[data-tour="show-more-activity"]',
      ...tourContent.account.showMoreActivity
    },
    {
      target: '[data-tour="refresh-credits"]',
      ...tourContent.account.refreshCredits
    },
    {
      target: '[data-tour="select-plan-button"]',
      ...tourContent.account.selectPlanButton
    },
    {
      target: '[data-tour="contact-sales-button"]',
      ...tourContent.account.contactSalesButton
    },
    {
      target: '[data-tour="add-payment-method"]',
      ...tourContent.account.addPaymentMethod
    },
    {
      target: '[data-tour="edit-payment-method"]',
      ...tourContent.account.editPaymentMethod
    },
    {
      target: '[data-tour="remove-payment-method"]',
      ...tourContent.account.removePaymentMethod
    },
    {
      target: '[data-tour="update-billing-info"]',
      ...tourContent.account.updateBillingInfo
    },
    {
      target: '[data-tour="download-invoice"]',
      ...tourContent.account.downloadInvoice
    }
  ]
};

// Helper function to get tour steps for a specific page
export const getTourSteps = (pageName) => {
  return tourSteps[pageName] || [];
};


